<app-sidemenu></app-sidemenu>
<router-outlet></router-outlet>
<ngx-spinner size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<div class="footer" *ngIf="view">
    <p class="copyright">Copyright © 2021 <strong class="theme-text-color">Crypto Exchange & QTE Token</strong> All Rights
        Reserved.</p>
</div>